export default {
  // 通用操作反馈
  'pages.common.add.success': '创建成功',
  'pages.common.edit.success': '更新成功',
  'pages.common.edit.fail': '更新失败',
  'pages.common.update.success': '更新成功',
  'pages.common.update.error': '更新失败',

  // 欢迎页
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',

  // 异常页
  'pages.403.subTitle': '抱歉，您没有权限访问此页面。',
  'pages.403.buttonText': '返回首页',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.500.subTitle': '抱歉，服务器发生错误。',
  'pages.500.buttonText': '返回首页',

};
